import { Column, Entity, JoinTable, ManyToMany, ManyToOne } from 'typeorm';
import Pedido from '../entity/Pedido';
import { serialize } from '../helper';
import PerguntaNoPedido, { criarListaPerguntasNoPedido } from './PerguntaNoPedido';
import Produto from './Produto';
import ProdutoBase, { criarProdutoBase } from './ProdutoBase';
import { TamanhoSelecionado } from './Tamanho';

@Entity()
export class ProdutoNoPedido extends ProdutoBase {
  @Column()
  quantidadeNoPedido: number = 1;

  @Column()
  produtoId: number = 0;

  @Column()
  observacao: string = '';

  @Column(() => TamanhoSelecionado)
  tamanhoSelecionado: TamanhoSelecionado = new TamanhoSelecionado();

  @ManyToOne(() => Pedido)
  pedido!: Pedido;

  @ManyToMany(() => PerguntaNoPedido, { eager: true, cascade: true })
  @JoinTable({ name: 'perguntas_no_pedido' })
  perguntasNoPedido?: PerguntaNoPedido[];
}

export default ProdutoNoPedido;

export const criarProdutoNoPedido = (produto: Produto) => {
  const produtoNoPedido = new ProdutoNoPedido();
  const produtoBase = criarProdutoBase(produto);
  Object.assign(produtoNoPedido, produtoBase);

  produtoNoPedido.perguntasNoPedido = criarListaPerguntasNoPedido(produto.perguntas);
  produtoNoPedido.produtoId = produto.id;

  return serialize<ProdutoNoPedido>(produtoNoPedido);
};
